<template>
  <div id="SalesProcess"
  class="background">
    <div v-show="module">
      <Banner :module="module" :baseURL="baseURL"/>
      <Navigation/>
      <Module :steps="steps" :module="module" :baseURL="baseURL"/>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/modules/SalesProcess/Banner.vue';
import Navigation from '@/components/home/Navigation';
import Module from '@/components/modules/SalesProcess/Module.vue';

  export default {
    name: 'SalesProcess',
    components: {
        Banner,
        Navigation,
        Module
    },

    data () {
      return {
        module: {
          "id": 5,
          "PageBanner": {
              "id": 4,
              "Title": "Sales process",
              "Body": "<p>In this module, we'll help you understand the relevant sales processes, opportunities, tools and resources available. So, you're able to build discussing general insurance into your conversations with clients, as well as during remortgage and product transfer.</p>",
              "Thumbnail": {
                  "id": 11,
                  "width": 500,
                  "height": 333,
                  "ext": ".png",
                  "mime": "image/png",
                  "url": "/assets/img/balls/sales_process.png",
              }
          },
          "Modules": [
              {
                  "id": 1,
                  "Title": "The opportunities",
                  "Description": "<p>In this chapter, we go through each relevant opportunity in the mortgage process where you can introduce general insurance into the conversation and the tools available to support you.</p>",
                  "File": {
                      "id": 1,
                      "ext": ".pdf",
                      "mime": "application/pdf",
                      "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2023-05-05/jjr91/682253/1683293327AbogS3Qj/Paymentshield_Sales_Opportunities_Workbook_02493_05052023.pdf",
                  }
              },
              {
                  "id": 2,
                  "Title": "The 3 quote process",
                  "Description": "<p>Understand what the 3 quote process is and when to use it in your sales process. Be aware of the alternative process to the 3 quote process and how best to utilise it when discussing general insurance.</p>",
                  "File": {
                      "id": 2,
                      "ext": ".pdf",
                      "mime": "application/pdf",
                      "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2023-05-05/jjrlm/682253/1683295261BVNTF6zh/Paymentshield_3_quote_process_Workbook_02494_05052023.pdf",
                  }
              },
              {
                  "id": 3,
                  "Title": "Remortgage & product transfer",
                  "Description": "<p>It's just as important to build a process for discussing general insurance with remortgage and product transfer clients as it is with other mortgage clients. This chapter helps you with building that process and explores the relevant tools to support you.</p>",
                  "File": {
                      "id": 3,
                      "ext": ".pdf",
                      "mime": "application/pdf",
                      "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2023-05-05/jjrlq/682253/1683295316aNMNWKj9/Paymentshield_Remortgage___product_transfer_Workbook_02495_05052023.pdf",
                  }
              },
              {
                  "id": 4,
                  "Title": "Download certificate",
                  "Description": "Once you've completed all of the chapters in this module please download your certificate.",
                  "File": {
                      "id": 4,
                      "name": ".pdf",
                      "ext": ".pdf",
                      "mime": "application/pdf",
                      "url": "https://info.paymentshieldadvisers.co.uk/l/682253/2023-05-05/jjrq7/682253/1683295831YG5m0PPK/PSL_Sales_process_Module_7_Certificate_05052023.pdf",
                  }
              }
          ]
      },
        baseURL: '',        
        steps: 4,
        totalSteps: '',
      }
    },
    mounted(){
      window.dataLayer.push({
        'event':'virtualPageView',
        'virtualPageURL':'/vpv/training-modules/sales-progress',
        'virtualPageTitle' : 'Sales Progress Test | GI Academy'
      }); 
    }
  }
</script>
